module.exports = __webpack_public_path__ + "img/avatar_dz.8faa3355.jpg";